import { useTranslation } from "react-i18next";
import { Save, X } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";

// شريط أوامر لاصق أسفل نموذج التعديل: يعمل على كل الشاشات.
export const EmployeeFormActions = ({ busy, invalid, dirty, onCancel }) => {
  const { t } = useTranslation();
  return (
    <div className="sticky bottom-4 z-20" data-testid="employee-form-actions">
      <div className="neu flex flex-col-reverse items-stretch gap-3 p-3 sm:flex-row sm:items-center sm:justify-end">
        {invalid ? (
          <span className="me-auto text-xs font-semibold text-destructive">
            {t("personal.fixErrors")}
          </span>
        ) : dirty ? (
          <span className="me-auto text-xs font-semibold text-amber-500">
            {t("guard.body")}
          </span>
        ) : null}
        <NeuButton type="button" data-testid="employee-cancel" onClick={onCancel} className="flex items-center justify-center gap-2">
          <X className="h-4 w-4" /> {t("app.cancel")}
        </NeuButton>
        <NeuButton
          variant="primary"
          type="submit"
          data-testid="employee-save"
          disabled={busy || invalid || !dirty}
          className="flex items-center justify-center gap-2"
        >
          <Save className="h-4 w-4" /> {t("app.save")}
        </NeuButton>
      </div>
    </div>
  );
};
